"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _formSerialize = _interopRequireDefault(require("form-serialize"));
var _jsxRuntime = require("react/jsx-runtime");
// t = current time, b = start value, c = change in value, d = duration
// http://stackoverflow.com/questions/8917921/cross-browser-javascript-not-jquery-scroll-to-top-animation
function easeInOutQuad(t, b, c, d) {
  /* eslint-disable no-param-reassign, no-mixed-operators */
  t /= d / 2;
  if (t < 1) {
    return c / 2 * t * t + b;
  }
  t--;
  return -c / 2 * (t * (t - 2) - 1) + b;
  /* eslint-enable no-param-reassign, no-mixed-operators */
}
function animateTo(_ref) {
  let {
    element,
    position = 0,
    duration = 250,
    onComplete = null
  } = _ref;
  const start = element.scrollTop;
  const change = position - start;
  const increment = 20;
  let currentTime = 0;
  const animateScroll = () => {
    currentTime += increment;
    element.scrollTop = easeInOutQuad(currentTime, start, change, duration);
    if (currentTime < duration) {
      window.setTimeout(animateScroll, increment);
    } else {
      if (onComplete) {
        onComplete();
      }
    }
  };
  animateScroll();
}
class Form extends _react.Component {
  constructor() {
    super(...arguments);
    this.state = {
      isValidationDebounced: false
    };
    this._formRef = /*#__PURE__*/(0, _react.createRef)();
    this._isMounted = true;
    this._onInvalid = evt => {
      const {
        focusFirstInvalid,
        onInvalid
      } = this.props;
      const {
        isValidationDebounced
      } = this.state;

      // debounce this because onInvalid of a form is called for every invalid field
      // this prevents multiple onInvalid calls from going out if multiple fields are invalid
      if (!isValidationDebounced) {
        if (focusFirstInvalid) {
          this._focusInvalid();
        }
        if (onInvalid) {
          onInvalid(evt);
        }
        this.setState({
          isValidationDebounced: true
        });
        setTimeout(() => {
          if (this._isMounted) {
            // Cypress is too fast unmounting so it never reaches this line and shows errors
            /* istanbul ignore next */
            this.setState({
              isValidationDebounced: false
            });
          }
        }, 1000);
      }
    };
    this._onSubmit = evt => {
      evt.preventDefault();
      const {
        includeEmptyWithSubmit,
        onSubmit
      } = this.props;
      if (onSubmit) {
        onSubmit({
          data: this.getValues(includeEmptyWithSubmit),
          evt
        });
      }
    };
    this._focusInvalid = () => {
      const {
        id,
        animateInvalidScroll,
        invalidElementToScroll,
        invalidElementScrollOffset
      } = this.props;

      // setTimeout to ensure elements are rendered with proper values first
      setTimeout(() => {
        const errorContainer = document.querySelector("#".concat(id, " [data-invalid-field=\"true\"]"));
        if (errorContainer) {
          const ariaInvalidNotHidden = '[aria-invalid="true"]:not([type="hidden"])';
          const errorItem = errorContainer.querySelectorAll("\n                    input".concat(ariaInvalidNotHidden, ",\n                    select").concat(ariaInvalidNotHidden, ",\n                    textarea").concat(ariaInvalidNotHidden, "\n                "))[0] || document.querySelector("#form");
          if (animateInvalidScroll) {
            const offsetTop = (errorItem === null || errorItem === void 0 ? void 0 : errorItem.offsetTop) || 0;
            animateTo({
              element: invalidElementToScroll || document.scrollingElement,
              position: offsetTop + invalidElementScrollOffset,
              onComplete: () => {
                errorItem.focus();
              }
            });
          } else {
            errorItem.focus();
          }
        }
      }, 100);
    };
  }
  componentWillUnmount() {
    this._isMounted = false;
  }
  /**
   * Animates the Form component to the first invalid field.
   *
   * @public
   * @returns {void}
   */
  animateToInvalid() {
    if (!this.isValid()) {
      this._focusInvalid();
    }
  }

  /**
   * Checks if the form is valid and ready for submission.
   *
   * @public
   * @returns {Boolean} - Whether the form is valid or not.
   */
  isValid() {
    return this._formRef.current.checkValidity ? this._formRef.current.checkValidity() : true;
  }

  /**
   * Retrieves the current values of the form fields.
   *
   * @public
   * @param {Boolean} [withEmpty=false] - Whether to serialize the empty fields.
   * @returns {Object} - The serialized form data.
   */
  getValues() {
    let withEmpty = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return (0, _formSerialize.default)(this._formRef.current, {
      hash: true,
      empty: withEmpty
    });
  }

  /**
   * Resets the form fields.
   *
   * @public
   * @returns {void}
   */
  reset() {
    const {
      current: $form
    } = this._formRef;
    $form.reset();
    // Set focus to the first element
    const notHidden = ':not([type="hidden"])';
    const notDisabled = ':not([disabled])';
    const $firstElement = $form.querySelector("\n            input".concat(notHidden).concat(notDisabled, ", \n            select").concat(notHidden).concat(notDisabled, ",\n            textarea").concat(notHidden).concat(notDisabled, "\n        "));
    if ($firstElement) {
      $firstElement.focus();
    }
  }

  /**
   * Provides the form data as an object for submission if all validation rules associated with the fields pass.
   *
   * @public
   * @param {Boolean} [withEmpty=false] - Whether to serialize the empty fields.
   * @returns {Object} - The serialized form data.
   */
  submit() {
    let withEmpty = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    if (!this.isValid()) {
      return null;
    }
    return this.getValues(withEmpty);
  }
  get node() {
    return this._formRef.current;
  }
  render() {
    const {
      className,
      testAttr,
      id,
      children,
      onChange
    } = this.props;
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("form", {
      ref: this._formRef,
      className: className,
      "data-test": testAttr,
      id: id,
      onChange: onChange,
      onSubmit: this._onSubmit,
      onInvalid: this._onInvalid,
      children: children
    });
  }
}
exports.default = Form;
Form.defaultProps = {
  testAttr: 'form',
  focusFirstInvalid: true,
  animateInvalidScroll: true,
  invalidElementScrollOffset: 0
};